import s from "./CategoryCardList.module.scss";
import alllCategories from '../../assets/travel_globe_transparent.svg';

const CategoryFixed = ({categories, onCategoryClick,activeCategory}) => {
    return (
        <div className={s.categoryList}>
            <div
                key={"all"}
                className={`${s.item} ${activeCategory===null ? s.active : ""}`}
                onClick={() => {

                    onCategoryClick("")
                }}
            >
                <div className={s.card}>
                    <img src={alllCategories} alt=""/>
                    <div className={s.overlayBelow}>

                        <div className={s.overlayBelowText}> すべてのツアー</div>
                    </div>
                </div>
            </div>

            {categories.slice(0, 7).map((item, i) => {
                const getColor = (item, i) => {

                    // If API has color, use it
                    if (item.color) {
                        return item.color;
                    }

                    // fallback colors
                    const colors = [
                        "#FF6B6B",
                        "#4ECDC4",
                        "#556270",
                        "#C7F464",
                        "#FFB400",
                        "#6C5CE7",
                        "#45B7D1",
                        "#96CEB4",
                        "#DDA0DD",
                        "#F7DC6F"
                    ];

                    // random color
                    return colors[Math.floor(Math.random() * colors.length)];
                };

                return (

                    <div
                        key={i}
                        className={`${s.item} ${activeCategory == item.id ? s.active : ""}`}
                        // style={{ flex: `0 0 ${100 / itemsPerView}%` }}
                        onClick={() => {

                            onCategoryClick(item.id)
                        }}
                    >
                        <div className={s.card}>
                            <img src={item.thumb} alt=""/>
                            <div className={s.overlayBelow}>

                                <div className={s.overlayBelowText}> {item.name}</div>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )

};

export default CategoryFixed;